import React from 'react';
import { SxProps, Theme, Tooltip, Typography, TypographyProps, useTheme } from '@mui/material';
import { useTranslation } from "react-i18next";
import ISONumber from './ISONumber';

export type RoundedNumberProps = {
  number: number;
  variant?: TypographyProps['variant'];
  component?: React.ElementType;
  sx?: SxProps<Theme> | undefined;
  tooltip?: boolean;
};

export default function RoundedNumber(props: RoundedNumberProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const variant = props.variant || "body1",
    typographyComponent: React.ElementType = props.component || "span";

  let n = props.number;
  let suffix = null;
  if(n >= 100000000000) {
    suffix = 'T';
    n /= 100000000000;
  } else if(n >= 100000000) {
    suffix = 'B';
    n /= 1000000000;
  } else if(n >= 1000000) {
    suffix = 'M';
    n /= 1000000;
  } else if(n >= 1000) {
    suffix = 'K';
    n /= 1000;
  }

  const displayNumber = n.toFixed(n >= 2 ? 0 : 1);

  const typeography = <Typography
    variant={variant} 
    component={typographyComponent}
    sx={props.sx}>
    {displayNumber}
    {suffix || ''}
  </Typography>

  if(props.tooltip) {
    return (
      <Tooltip title={<ISONumber sx={{fontWeight:"bold", color:theme.colors.primary.main }} number={Math.round(props.number)} />}>
        {typeography}
      </Tooltip>
    );
  } else {
    return typeography;
  }
  
}